import { put, takeLatest, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import checkoutAPI from '../../api/checkout';
import { Types, Creators as CheckoutCreators } from '../../reducers/checkout';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* pixPaymentRequest({ seller }) {
  const sellerId = seller.getIn(['seller', 'id']);

  try {
    const token = yield select(getToken);
    const { app } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);
    const plataform = app.getIn(['plataform']);

    const size = plataform === 'mobile' ? 230 : 350;

    const queryParams = {
      media: 'SVG',
      width: size,
      height: size,
    };

    const data = yield call(checkoutAPI.pixPayment, seller.getIn(['hash']), token, siteId, queryParams);

    yield put(CheckoutCreators.pixPaymentSuccess(sellerId, data));
  } catch (error) {
    yield put(CheckoutCreators.pixPaymentError(sellerId, formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.PIX_PAYMENT_REQUEST, pixPaymentRequest);
}
